var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "M20.125 9.583c0 6.709-8.625 12.459-8.625 12.459s-8.625-5.75-8.625-12.459a8.625 8.625 0 1 1 17.25 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "M11.5 12.458a2.875 2.875 0 1 0 0-5.75 2.875 2.875 0 0 0 0 5.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.575e121b.svg";
export { ForwardRef as ReactComponent };